<mat-card>
    <mat-card-content>
        <div class="logo-container">
            <img src="assets/logo-apaisado.svg" alt="Coverpordias Logo" class="logo-image" />
        </div>
        <div class="result-container" *ngIf="result === 'ok'; else paymentKo">
            <ng-container *ngIf="isLoadingPolicyData; else policyResult">
                <h3>Estamos obteniendo los datos de tu póliza, un momento.</h3>
            </ng-container>
            <ng-template #policyResult>
                <ng-container *ngIf="hasPolicyData(); else policyPending">
                    <h3>Gracias por contratar tu seguro con nosotros.<br />
                        Puedes descargar la póliza {{ numPoliza }} ahora.</h3>
                    <br />
                    <button mat-raised-button color="primary" (click)="downloadPolicy(1)">Descargar condiciones
                        generales</button><br />
                    <button mat-raised-button color="primary" (click)="downloadPolicy(2)">Descargar condiciones
                        particulares</button><br />
                    <button mat-raised-button color="primary" (click)="downloadPolicy(3)">Descargar recibo</button>
                </ng-container>
            </ng-template>
            <ng-template #policyPending>
                <h3>Gracias por contratar tu seguro con nosotros.</h3>
                <p>Tu póliza se está procesando y la recibirás por email tan pronto como esté lista.</p>
            </ng-template>
            <br />
            <h2>Importante</h2>
            <p>Lleva siempre una copia de tu póliza de seguro y recibo de pago en tu vehículo ,
                a fin de evitar sanciones por no aparecer de forma inmediata en las bases de datos de DGT.</p>
            <p>Aunque tu vehículo ya está asegurado, en condiciones normales, la póliza tarda en aparecer en el
                fichero FIVA aproximadamante 48 horas desde su fecha de efecto, si esta tiene lugar de lunes a jueves
                no festivos, y de 72 horas si se realiza en otro supuesto.</p>
            <p>Lee detenidamente la información sobre la incluisón en ficheros FIVA y
                que debes hacer si te multan por no aparecer en la base de datos DGT <a
                    href="https://www.coverpordias.es/seguro-temporal-condiciones" target="_blank">aquí</a>
            </p>
        </div>

        <ng-template #paymentKo>
            <div class="result-container">
                <h2>Pago no realizado</h2>
                <p>Lo sentimos, pero su pago no ha podido ser procesado.</p>
                <button mat-raised-button color="warn" (click)="goToHome()">Reintentar</button>
            </div>
        </ng-template>
    </mat-card-content>
</mat-card>